import Styles from './BlazeRecommendations.module.scss'
import ImageMenuModalStyles from '../ImageMenuModal.module.scss'
import { useImageMenuContext } from '../ImageMenuContext'
import { ImageThumbnail } from 'components/ImagePickerModal/ImageThumbnail/ImageThumbnail'
import { Grid } from 'components/ImagePickerModal/Grid/Grid'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { useBlazeRecommendations } from './useBlazeRecommendations'
import { useBlazeImageSelection } from './useBlazeImageSelection'
import { GeneratingRecommendation } from './GeneratingRecommendation'
import { Modal } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Actions } from '../ImageMenuModal'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const BlazeRecommendations = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { setProvider } = useImageMenuContext()
  const { toggle, isSelected } = useBlazeImageSelection()
  const { recommendations, updateRecommendation, removeRecommendation, fetchNextPage, hasNextPage, brandProfileId } =
    useBlazeRecommendations()

  if (!brandProfileId) return null

  return (
    <>
      <Modal.Header
        className={ImageMenuModalStyles.header}
        actions={<Actions />}
        title="Blaze recommendations"
        onBack={() => setProvider('')}
      />
      <Modal.Content className={Styles.content} withoutFooter={isSystemRedesignEnabled}>
        <div className={Styles.description}>
          <Heading level={5}>
            We've found a few images and videos that may align with your brand. Please choose images/videos to create
            content with.
          </Heading>
        </div>
        <div className={Styles.gridContainer}>
          <ScrollContainer>
            <Grid.Root breakpointCols={4}>
              {recommendations.map((rec) => {
                if (rec.type === 'placeholder') {
                  return (
                    <Grid.Thumbnail key={rec.id}>
                      <GeneratingRecommendation
                        id={rec.id}
                        brandProfileId={brandProfileId}
                        onSuccess={updateRecommendation}
                        onError={removeRecommendation}
                        variant="grid"
                      />
                    </Grid.Thumbnail>
                  )
                }
                if (!rec.image) return null
                const image = rec.image
                return (
                  <Grid.Thumbnail key={rec.id}>
                    <ImageThumbnail
                      image={image}
                      onToggleSelect={() => toggle(image)}
                      isSelected={isSelected(image.url)}
                    />
                  </Grid.Thumbnail>
                )
              })}
            </Grid.Root>
          </ScrollContainer>
        </div>
        {hasNextPage && (
          <div className={Styles.infiniteLoader}>
            <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
          </div>
        )}
      </Modal.Content>
    </>
  )
}
